import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'gt-dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['./dialog-header.component.scss']
})
export class DialogHeaderComponent {
  @Input() message = '';
  @Input() disableClose = false;
  @Output() closing = new EventEmitter();
}
